import _ from 'lodash';

export const isActiveCrossSell = (state, appType) => {
  const ifpApp = _.find(state.ifpApps, { type: appType });
  const cartApps = _.get(state, 'cart.ifpApps', []);
  const crossSells = _.get(state, 'ifpCrossSell.all', []);

  // if the target type app was created as part of cross sell
  const xSell = ifpApp ? _.find(crossSells, { target_app_id: ifpApp.app_id }) : null;

  // and the source it was created from is in the cart
  const sourceApp = xSell ? _.find(cartApps, { app_id: xSell.source_app_id }) : null;

  return !!sourceApp;
};
